import _ from 'lodash';
import moment from 'moment';
import { DEFAULTS } from '@/constants';

export * from './editFile.helper';

export const getFilesTypes = (disabledTypes = []) => {
  return DEFAULTS.MATCHER.FILES_TYPES.map((fileType) => {
    const isDisabled = disabledTypes.find((type) => type === fileType.value);

    return isDisabled ? { ...fileType, disabled: true } : fileType;
  });
};

export const checkIsLastRunOld = (result) => {
  const createdAt = moment(_.get(result, 'created_at'));

  return moment().diff(createdAt, 'days') >= 30;
};

export const downloadBlobByLink = (name, fileBlob, mimeType) => {
  const blob = new Blob([fileBlob], {
    type: mimeType
  });

  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = name;
  link.click();
  URL.revokeObjectURL(link.href);
};

export const isCsvFile = (fileName) => fileName.split('.').pop() === 'csv';

export const getFilesTypesByExtension = (fileName) => {
  const isCsv = isCsvFile(fileName);
  const disabledTypesList = isCsv ? [] : ['common'];

  return getFilesTypes(disabledTypesList);
};
